import { Input, message } from 'antd'
import clsx from 'clsx'
import React, { ChangeEvent, KeyboardEvent, useEffect, useState } from 'react'
import Select from 'react-select'
import SunEditor, { buttonList } from 'suneditor-react';
import {
  blockquote,
  align,
  font,
  fontColor,
  fontSize,
  formatBlock,
  hiliteColor,
  horizontalRule,
  lineHeight,
  list,
  paragraphStyle,
  table,
  template,
  textStyle,
  image,
  link,
  video,
  audio,
  math,
  imageGallery
} from 'suneditor/src/plugins'
import 'suneditor/dist/css/suneditor.min.css';
import { toAbsoluteUrl } from '../../_metronic/helpers';
import { useFormik } from 'formik';
import httpService from '../../setup/http/httpServices';
import { Link, useHistory } from 'react-router-dom';
import { handleFileUpload } from '../../setup/Upload/Upload';
import { number } from 'yup';
import moment from 'moment';

type Props = {}




const AddBlog = (props: Props) => {
  const blogPreData = JSON.parse(localStorage.getItem('blogPreviewData') || '{}');
  const [title, setTitle] = useState(blogPreData.title || '')
  const [subtitle, setSubtitle] = useState(blogPreData.subtitle || '')
  const [readTime, setReadTime] = useState(blogPreData.readingTime || '')



  const history: any = useHistory()
  const [blogContent, setBlogContent] = useState(blogPreData.content)
  const [blogCat, setBlogCat] = useState(blogPreData.category || [])
  const [img, setImg] = useState(blogPreData.image || "")
  const [phraseInput, setPhraseInput] = useState<string>('')
  const [phrase, setPhrase] = useState<string[]>(blogPreData.phrases || [])
  const [errorMessage, setErrorMessage] = useState('');
  const [selectAllMode, setSelectAllMode] = useState<boolean>(true);
  const [date, setDate] = useState(blogPreData.publishDate || '');
  const [time, setTime] = useState(blogPreData.publishTime || '');

  console.log('date', date)
  // console.log('history.location.state?.blog?.publishDate', history.location.state?.blog?.publishDate)
  console.log('blogPreData.publishDate', blogPreData.publishDate)

  const formatDate = (inputDate: string): string => {
    const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
    const formattedDate: string = new Date(inputDate).toLocaleDateString('en-GB', options);
    return formattedDate.split('/').join('-');
  };

  //  Function to convert date format
  const convertDateFormet = (inputDate: any): string => {
    // Split the input date string by "-"
    const parts = inputDate?.split("-");

    // Rearrange the parts to create a new date string in the format "YYYY-MM-DD"
    const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
    return formattedDate;
  };



  const handleDateChange = (event) => {
    setDate(event.target.value);
  };

  const handleTimeChange = (event) => {
    setTime(event.target.value);
  };



  //   Preview Blog for localStorage Data
  const previewData = {
    title: title,
    subtitle: subtitle,
    readingTime: readTime,
    content: blogContent,
    category: blogCat,
    phrases: phrase,
    image: img,
    publishDate: date,
    publishTime: time
  }
  localStorage.setItem('blogPreviewData', JSON.stringify(previewData));

  // console.log('previewData', previewData)






  const [blogCatData, setBlogCatData] = useState([])

  const formik = useFormik({
    initialValues: {},
    onSubmit: async (values) => {

      console.log('data', {
        title,
        subtitle,
        readTime,
        blogContent,
        blogCat,
        phrase
      });

      if (!title || !subtitle || !readTime || phrase?.length == 0 || !blogContent || !blogCat || !img) return;

      const arr = []
      for (const i of blogCat) {
        const obj = {
          _id: i.value,
          Name: i.label,
          AssociatedPhrases: i.AssociatedPhrases,
        }
        arr.push(obj)
      }

      const obj = {
        title: title,
        subtitle: subtitle,
        readingTime: readTime,
        content: blogContent,
        category: arr,
        phrases: phrase,
        image: img,
        publishDate: formatDate(date),
        publishTime: time
      }

      if (history?.location?.state?.edit) {
        await httpService.patchData(
          '/blogPost/' + history?.location?.state?.blog?._id,
          obj,
          (res) => {
            console.log(res);
            message.success("blog edited sucessfully")
            history.push({
              pathname: "/Blogs"
            })
          },
          (err) => {
            message.error(err?.message || "Published blogs cannot be edited")

          }
        )
      }
      else {
        await httpService.postData(
          '/blogPost',
          obj,
          (res) => {
            console.log(res);
            localStorage.removeItem('blogPreviewData');
            message.success("blog added sucessfully")
            history.push({
              pathname: "/Blogs"
            })
          },
          (err) => {
            message.error(err?.message || "Something went wrong")
            console.log(err);

          }
        )
      }
    }
  })

  const onChangeImg = async (event: any) => {
    const d = await handleFileUpload(event, 1120, 630);
    console.log(d);
    setImg(d ? d : '')
  }

  const getData = async () => {
    await httpService.getData(
      "/blogCategory",
      (res) => {
        console.log("blog res", res);
        const arr = []
        for (const i of res.data.data.data) {
          const obj = {
            label: i.Name,
            value: i._id,
            AssociatedPhrases: i.AssociatedPhrases

          }
          arr.push(obj)
        }
        setBlogCatData(arr)
      },
      (err) => {
        message.error(err?.message || "Something went wrong")
      }
    )
  }

  useEffect(() => {
    getData()
  }, [])

  useEffect(() => {
    if (history?.location?.state?.edit) {
      console.log(history.location.state)
      setTitle(history.location.state?.blog?.title)
      setSubtitle(history.location.state?.blog?.subtitle)
      setReadTime(history.location.state?.blog?.readingTime)
      setBlogContent(history.location.state?.blog?.content)
      setPhrase(history.location.state?.blog?.phrases)
      setImg(history.location.state?.blog?.image)
      setDate(convertDateFormet(history.location.state?.blog?.publishDate))
      setTime(history.location.state.blog?.publishTime)
      const arr = []
      for (const i of history.location.state?.blog?.category) {
        const obj = {
          label: i?.Name,
          value: i?._id,
          AssociatedPhrases: i?.AssociatedPhrases

        }
        arr.push(obj)
      }
      setBlogCat(arr)
    }
    // console.log('edit cat', history?.location?.state)
  }, [])



  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPhraseInput(e.target.value);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    console.log("key", e.key)
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      addPhrase();
    }
  };

  const addPhrase = () => {
    if (phraseInput.trim() !== '') {
      const updatedPhrases = [...phrase, phraseInput.trim().replace(/,$/, '')];
      setPhrase(updatedPhrases);
      setPhraseInput('');
    }
  };

  const handleRemovePhrase = (phraseIndex: number) => {
    setPhrase((prevPhrases) => prevPhrases.filter((_, index) => index !== phraseIndex));
  };

  const handleSuggestionClick = (suggestedPhrase: string) => {
    const lowerCaseSuggestedPhrase = suggestedPhrase.toLowerCase();
    // Convert existing phrases to lowercase for case-insensitive comparison
    const lowerCasePhrases = phrase.map(item => item.toLowerCase());
    if (lowerCasePhrases.includes(lowerCaseSuggestedPhrase)) {
      setErrorMessage('Phrase already exists');
    } else {
      // If not, add the suggestedPhrase to the array and clear the error message
      const updatedPhrases = [...phrase, suggestedPhrase];
      setPhrase(updatedPhrases);
      setErrorMessage('');
    }
  };

  const handleToggleSelectAllSuggestions = () => {
    const allSuggestedPhrases = blogCat?.flatMap((item) => item?.AssociatedPhrases);

    if (selectAllMode) {
      setPhrase(allSuggestedPhrases);
    } else {
      setPhrase([]);
    }
    setSelectAllMode(!selectAllMode);
  };



  return (
    <div style={{ minHeight: '80vh' }}>
      <div className="CompanyDetailsOuter">
        <form
          noValidate
          id='kt_sign_up_submit'
          onSubmit={async (e) => {
            await e.preventDefault()
          }}
          style={{ marginBottom: '100px' }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
            <div className='CompanyDetails'>
              <div className='row pt-4 pe-5 pb-5' style={{ gap: "1rem" }}>
                <div className="col-12">
                  <h6 className='fw-bold required'>Enter Blog Title</h6>
                  <Input
                    type='text'
                    value={title}
                    onChange={e => setTitle(e.target.value)}
                    placeholder='enter blog title'
                    style={{ height: "45px" }}
                    className={clsx(
                      ' form-control-solid shadow-none border-0 rounded-4 bg-gray-100',
                      // {
                      //   'is-invalid':
                      //     (formik.touched.websiteURL && formik.errors.websiteURL) || nameError,
                      // },
                      // {
                      //   'is-valid': formik.touched.websiteURL && !formik.errors.websiteURL,
                      // }
                    )}

                  />

                </div>
                <div className="col-12">
                  <h6 className='fw-bold required'>Enter Blog SubTitle</h6>
                  <Input
                    type='text'
                    value={subtitle}
                    onChange={e => setSubtitle(e.target.value)}
                    placeholder='enter blog subtitle'
                    style={{ height: "45px" }}
                    className={clsx(
                      ' form-control-solid shadow-none border-0 rounded-4 bg-gray-100',
                    )}
                  />
                </div>
                <div className="col-12 mt-7" style={{ width: "100%", display: "flex", }}>
                  <div className="time-box">
                    <h6 className='fw-bold required'>Enter Read Time (in mins)</h6>
                    <Input
                      type="text"
                      value={readTime}
                      onChange={e => setReadTime(e.target.value)}
                      placeholder='ex. 5'
                      style={{ height: "45px" }}
                      className={clsx(
                        ' form-control-solid shadow-none border-0 rounded-4 bg-gray-100',
                      )}
                    />
                  </div>
                  <div className="d-flex align-items-end ps-10">

                    <div className="box">
                      <h6 className='fw-bold required'>Upload Blog Cover Image</h6>
                      <p>Image dimensions must be 1120 x 630</p>
                    </div>
                    {/* <h6 className='fw-bold required'>Upload Blog Cover Image</h6> */}
                    <button
                      className='btn btn-gray-200 screenshotComponentBtn border border-gray-500 w-200px mx-4'
                      type='button'
                      onClick={() => {
                        document.getElementById('imgblog').click()
                      }}
                    >
                      Click to Upload
                    </button>
                    <input
                      type='file'
                      accept='.png, .jpg, .jpeg, .svg'
                      style={{ display: 'none' }}
                      id={'imgblog'}
                      onChange={onChangeImg}
                    />
                    {
                      img &&
                      <button
                        className={
                          !img
                            ? 'btn btn-gray-200 screenshotComponentBtn border border-gray-500'
                            : 'screenshotComponentBtn'
                        }
                        onClick={() => {
                          window.open(img, '_blank')
                        }}
                        type='button'
                      >
                        <img src={toAbsoluteUrl('/media/icons/Custom/eye.svg')} alt='eye' /> &nbsp;
                        Preview
                      </button>
                    }
                  </div>
                </div>
                <div className="col-12 mt-7">
                  <h6 className='fw-bold required'>Select Blog Category (comma separated values)</h6>
                  <Select
                    isMulti={true}
                    onChange={(e: any) => {
                      setBlogCat([...e])

                    }}
                    value={blogCat}
                    className={clsx(
                      'text-gray-500 form-control form-control-solid rounded-4 bg-gray-100 p-0 border-0 categorySelect'
                    )}
                    styles={{
                      menuList: (provided, state) => ({
                        ...provided,
                        height: 'auto',
                        minHeight: '45px',
                        maxHeight: '200px',
                      }),
                      control: (baseStyles, state) => ({
                        display: 'flex',
                        justifyContent: "space-between",
                        minHeight: '45px'
                      })
                    }}
                    options={blogCatData}
                    placeholder='Select Page Category'
                  />
                </div>

              </div>
            </div>

            <div className="CompanyDetails">
              <h2 className=''>Associated Phrases</h2>
              <div className="row">
                <div className="col">

                  <p className='required'>Manage Phrases (comma separated values)</p>
                  <div className='website-phrases-field'>
                    {phrase.map((phrase, index) => (
                      <div className='d-flex align-items-center justify-content-around border px-3 py-2 m- rounded-pill'>
                        {phrase}
                        <img
                          style={{ paddingLeft: '5px', cursor: 'pointer', display: 'inline' }}
                          onClick={() => handleRemovePhrase(index)}
                          src={toAbsoluteUrl('/media/icons/Custom/Cross.svg')}
                          alt='cross'
                        />
                      </div>
                    ))}
                    <input
                      type='text'
                      onChange={handleInputChange}
                      onKeyUp={handleKeyDown}
                      value={phraseInput}
                    />
                  </div>
                </div>
              </div>
              <div className="suggest-phrases-box">
                <div className="suggest-header-box">
                  <p style={{ marginTop: "2rem", padding: 0 }}>Suggested Phrases from Category Master</p>
                  <div className='custom-btn' onClick={handleToggleSelectAllSuggestions}>
                    {selectAllMode ? 'Select All Phrases' : 'Cancel All Phrases'}
                  </div>
                </div>
                <div className="suggest-phrases">
                  {blogCat?.map((item, index) => (
                    <div key={index} className='phrases-box'>
                      {item?.AssociatedPhrases?.map((item: any, index: any) => (
                        <div className='phrases' onClick={() => handleSuggestionClick(item)} key={index}>{item}</div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
              {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
            </div>
            {!history?.location?.state?.isPublished &&
              <div className="CompanyDetails d-flex align-items-center justify-content-between">
                <h2>Publish Schedule</h2>
                <div className="d-flex align-items-center">
                  <div className="date-field">
                    <input
                      type="date"
                      className='form-control bg-gray-200'
                      value={date}
                      onChange={handleDateChange}
                      placeholder='Select Date'
                    />
                  </div>
                  <div className="time-field ms-8">
                    <input
                      type="time"
                      className='form-control bg-gray-200'
                      value={time}
                      onChange={handleTimeChange}
                      placeholder='Select Time'
                    />
                  </div>
                </div>
              </div>
            }


            <div className="CompanyDetails">
              <div className='row pe-5 pb-5'>
                <div className="col-12">
                  <h5 className='mb-6'>Blog Content</h5>
                  <SunEditor
                    setAllPlugins
                    setOptions={{
                      height: '400px',
                      plugins: [
                        blockquote,
                        align,
                        font,
                        fontColor,
                        fontSize,
                        formatBlock,
                        hiliteColor,
                        horizontalRule,
                        lineHeight,
                        list,
                        paragraphStyle,
                        table,
                        template,
                        textStyle,
                        image,
                        link,
                        video,
                        audio,
                        math,
                        imageGallery
                      ],
                      buttonList: [
                        ['undo', 'redo'],
                        ['font', 'fontSize', 'formatBlock'],
                        ['paragraphStyle', 'blockquote'],
                        ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                        ['fontColor', 'hiliteColor', 'textStyle'],
                        ['removeFormat'],
                        '/', // Line break
                        ['outdent', 'indent'],
                        ['align', 'horizontalRule', 'list', 'lineHeight'],
                        ['table', 'link', 'image', 'video', 'audio' /** ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.
                        /** ['imageGallery'] */ // You must add the "imageGalleryUrl".
                        ['fullScreen', 'showBlocks', 'codeView'],
                        ['preview', 'print'],
                        ['save', 'template'],
                        /** ['dir', 'dir_ltr', 'dir_rtl'] */ // "dir": Toggle text direction, "dir_ltr": Right to Left, "dir_rtl": Left to Right
                      ]
                    }}
                    defaultValue={blogContent}
                    setContents={blogContent}
                    onChange={e => {
                      setBlogContent(e)
                    }}
                  />

                </div>
              </div>
            </div>



            {/* <div className="CompanyDetails">
              <div className="row">
                <div className="col">
                  <h5 className='mb-6'>Blog Phrases</h5>
                
                  <p>Add Phrases (comma separated values) <span style={{ color: 'red' }}></span>*</p>
                  <Input
                    type='text'
                    placeholder='Enter Phrase'
                    className='form-control-solid rounded-6 border shadow-none pe-6 bg-white-100 mb-5'
                    onChange={(e) => {
                      console.log(e)
                      setPhraseInput(e.target.value)
                    }
                    }
                    name='phraseInput'
                    onKeyUp={e => {
                      e.preventDefault()
                      if (e.key == 'Enter') {
                        if (phraseInput.length <= 0) return;
                        const arr2 = phraseInput.split(",")
                        const arr = [...phrase, ...arr2]
                        setPhrase(arr)
                        setPhraseInput('')
                      }
                    }}
                    value={phraseInput}
                    prefix={
                      <>
                        <img src={toAbsoluteUrl('/media/icons/Custom/Search.svg')} alt='link' />
                      </>
                    }
                  />
                 

                </div>
              </div>
              <div className='row pt-4 pe-5 '>
                <div className='col d-flex flex-row  justify-content-start align-items-center flex-wrap'>
                  {phrase &&
                    phrase?.map((x, ind) => {
                      return (
                        <div className='d-flex align-items-center justify-content-around border px-3 py-2 m-2 rounded-pill'>
                          {x}
                          <img
                            style={{ paddingLeft: '5px', cursor: 'pointer', display: 'inline' }}
                            onClick={() => {
                              const arr = [...phrase]
                              arr.splice(ind, 1)
                              setPhrase(arr)
                            }}
                            src={toAbsoluteUrl('/media/icons/Custom/Cross.svg')}
                            alt='cross'
                          />
                        </div>
                      )
                    })}
                </div>
              </div>
            </div> */}

            <div className='d-flex pt-4 pe-5 justify-content-start' style={{ justifyContent: 'start', width: "100%" }}>
              <button
                onClick={() => formik.handleSubmit()}
                className='btn btn-primary ms-5 CompanyDetailButton'
              // disabled={loading || mobfetchErr || deskfetchErr}
              >
                <span className='indicator-label'>Submit</span>
                {/* {loading && (
                <span className='indicator-progress' style={{ display: 'block' }}>
                  Please wait...{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )} */}
              </button>
              <Link
                to={{
                  pathname: '/addBlog/preview',
                }}
              >
                <button type='button' className='btn btn-primary ms-5 CompanyDetailButton' disabled={!title || !subtitle || !readTime || phrase?.length == 0 || !blogContent || !blogCat || !img}>
                  Preview Blog
                </button>
              </Link>
              <Link
                to={{
                  pathname: '/blogs',
                }}
              >
                <button type='button' className='btn fw-bolder btn-gray-200 ms-5 CompanyDetailButton'>
                  Cancel
                </button>
              </Link>


            </div>
          </div>

        </form>
      </div>
    </div>
  )
}

export default AddBlog